import React from 'react'
import LoaderImg from '../../../assets/images/helloSuperStar.png'

const Loader = () => {
  return (
    <>
      <div className="preloader flex-column justify-content-center align-items-center">
        <img className="animation__wobble" src={LoaderImg} alt="AdminLTELogo" height="160" width="160" />
      </div> 
    </>
  )
}

export default Loader



